<template>
  <div
    :id="`${name}_card-wrapper`"
    class="select-group-field"
    :question-id="`question_${questionNum}`"
    :class="[wrapperStyle.class]"
    :style="[wrapperStyle.style]"
  >
    <div
      class="col-12 card"
      :class="[cardStyle.class]"
      :style="[cardStyle.style]"
    >
      <div
        class="card-content"
        :style="{ padding: questionNum ? '0px' : '16px' }"
      >
        <div class="card-title" v-if="titleText">
          {{ titleText }}
          <!-- <button
            class="button btn waves-effect shadow-depth indigo accent-2 btn-helper"
          >
            <i class="material-icons material-icons-outlined">help_outline</i>
          </button> -->
        </div>
        <div class="label-text" v-if="!questionNum">
          {{ label }}
        </div>
        <div
          class="label-text"
          style="display:flex;color: #707070; font-size: 18px;"
          v-else
        >
          <div style="margin-right:5px;">{{ questionNum + "." }}</div>
          {{ label }}
        </div>
        <div :style="{ padding: questionNum ? '16px' : '' }">
          <div
            class="image-preview"
            :class="[{ 'img-wrapper-survey': forSurvey }]"
          >
            <img :src="previewImage" alt="" srcset="" />
          </div>

          <div class="input-field selector-wrapper">
            <div class="selector-trigger" @click="showSelector = true"></div>
            <select
              :class="[fieldStyle.class, { 'browser-default': browserDefault }]"
              :style="[fieldStyle.style]"
              :id="`${name}_card_select`"
              :ref="`${name}_card_select`"
              v-model="fieldValue"
              :disabled="isDisabled"
            >
              <option
                :value="option.value"
                v-for="(option, index) in options"
                :key="index"
                :disabled="option.default"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <option-selector
      :name="selectorName"
      :gridStyle="selectorGridStyle"
      :data-options="options"
      :data-value="fieldValue"
      :data-for-survey="forSurvey"
      @updateSelector="$_updateSelectorValue"
      v-if="showSelector"
    ></option-selector>
  </div>
</template>
<script>
import OptionSelector from "../../addons/OptionSelector.vue";

export default {
  components: { OptionSelector },
  name: "CustomSelectField",
  props: {
    value: {
      type: [String, Number],
      default: () => "",
    },
    name: {
      type: String,
      required: true,
    },
    forSurvey: {
      type: Boolean,
      default: true,
    },
    selectorName: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      required: false,
    },
    titleText: {
      type: String,
      default: () => "",
    },

    selectorGridStyle: {
      type: [Object],
      default: () => ({}),
    },
    questionNum: {
      type: Number,
      default: () => null,
    },
    showLabel: {
      type: Boolean,
      default: true,
      required: false,
    },
    browserDefault: {
      type: Boolean,
      default: () => true,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    helperText: {
      type: String,
      required: false,
      default: "",
    },
    autoComplete: {
      type: Boolean,
      default: () => true,
    },
    wrapperStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    cardStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    fieldStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    icon: {
      type: String,
      required: false,
    },
    groupTag: {
      type: String,
      default: () => "",
    },
    error: {
      type: String,
      required: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
      reuqired: false,
    },
  },
  data() {
    return {
      fieldValue: this.value,
      showSelector: false,
    };
  },
  mounted() {},
  computed: {
    previewImage() {
      const hasDefault = this.options.find((item) => item.default);
      const opt = this.options.find(
        ({ value }) => value === this.fieldValue && value !== null
      );

      if (opt) {
        return opt.localImage;
      } else {
        if (hasDefault) {
          return this.options[1].localImage;
        } else {
          return this.options[0].localImage;
        }
      }
    },
  },
  methods: {
    $_setValue() {
      const ObjLen = Object.keys(this.value).length;
      if (ObjLen <= 0) {
        this.fieldValue = this.optOne;
      }
    },
    $_setSelected(item) {
      if (this.fieldValue.value === item.value) return;
      this.fieldValue = item;
      this.$_updateValue();
    },
    $_updateValue() {
      // console.log(error, hasError);
      this.$emit("update", this.fieldValue);
    },
    $_updateSelectorValue(value) {
      this.fieldValue = value;
      this.showSelector = false;
      this.$_updateValue();
    },
    $_getImg(pic) {
      if (pic) {
        return require("@/assets/" + pic);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.select-group-field {
  .card-content {
    // padding: 0 !important;
    .card-title {
      //   display: flex;
      //   justify-content: space-between;
      //   align-items: center;
    }
    .btn-helper {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 32px;
      width: 32px;
      border-radius: 50%;

      i {
        font-size: 24px;
      }
    }

    .image-preview {
      margin-top: 1rem;
      border-radius: 5px;
      height: 140px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .img-wrapper-survey {
      display: flex;
      justify-content: center;
      img {
        margin: 0 auto;
        width: auto;
        height: 100%;
      }
    }
    .selector-wrapper {
      position: relative;
      .selector-trigger {
        position: absolute;
        top: 0;
        // left: 0;
        width: calc(100% - 21px);
        height: 100%;
        // border: 1px solid white;
        // background: red;
        // background: red;
      }
    }

    .label-text {
      // margin-top: 1rem;
    }

    .btn-container {
      margin: 1rem 0;
    }
  }
}
</style>
